import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { AgendaWaitlistBooking } from "./AgendaWaitlistBooking";
import { AgendaWaitlistBookings_Agenda$key } from "./__generated__/AgendaWaitlistBookings_Agenda.graphql";

type AgendaWaitlistBookingsProps = {
  agendaRef: AgendaWaitlistBookings_Agenda$key;
  onWaitlistBookingPress: (bookingId: string) => void;
};

export const AgendaWaitlistBookings = ({
  agendaRef,
  onWaitlistBookingPress,
}: AgendaWaitlistBookingsProps) => {
  const agenda = useFragment(AgendaWaitlistBookingsFragmentString, agendaRef);
  const NoRequestHeader = () => {
    return staffBookings?.length > 0 ? (
      <Text pt={6} pb={4} variant="mainBaseMedium">
        {t`No Requested Time`}
      </Text>
    ) : null;
  };

  const memberRequestedBookings =
    agenda?.queueSlot.bookings?.edges
      ?.filter((b) => b?.node && b?.node.request !== null)
      .sort((a, b) =>
        (a?.node?.request?.time ?? "").localeCompare(
          b?.node?.request?.time ?? ""
        )
      ) || [];

  const staffBookings =
    agenda?.queueSlot.bookings?.edges?.filter(
      (b) => b?.node && b?.node.request === null
    ) || [];

  return (
    <Box>
      <VStack>
        {memberRequestedBookings.map((item, index) => {
          return item?.node ? (
            <Box mt={index > 0 ? 2 : 0} key={item.node.id}>
              <AgendaWaitlistBooking
                key={index}
                queryRef={item.node}
                onWaitlistBookingPress={(bookingId) =>
                  onWaitlistBookingPress(bookingId)
                }
              />
            </Box>
          ) : null;
        })}
      </VStack>
      <NoRequestHeader />
      <VStack>
        {staffBookings.map((item, index) => {
          return item?.node ? (
            <Box mt={index > 0 ? 2 : 0} key={item.node.id}>
              <AgendaWaitlistBooking
                key={index}
                queryRef={item.node}
                onWaitlistBookingPress={(bookingId) =>
                  onWaitlistBookingPress(bookingId)
                }
              />
            </Box>
          ) : null;
        })}
      </VStack>
    </Box>
  );
};

export const AgendaWaitlistBookingsFragmentString = graphql`
  fragment AgendaWaitlistBookings_Agenda on Agenda {
    id
    date
    queueSlot {
      id
      queueCount: bookings {
        count
      }

      bookings(
        first: 1000
        orderBy: { field: REQUESTED_DATE_TIME, direction: ASC }
      ) @connection(key: "queueSlot_bookings") {
        edges {
          node {
            id
            ... on StandardBooking {
              request {
                time
              }
            }
            ... on LessonBooking {
              request {
                time
              }
            }
            ...AgendaWaitlistBooking_Booking
          }
        }
      }
    }

    facility {
      club {
        supportsPublic
      }
    }

    waitlistRestrictions: bookingRules(
      type: [WAITLIST]
      courseIds: $courseIds
    ) {
      edges {
        liftAt
        node {
          id
        }
      }
    }
  }
`;
